import { VChip } from 'vuetify/lib/components/index.mjs';

export const chipDefaults: Partial<VChip> = {
  class: [
    'px-2',
    'ga-2',
    'text-none',
    'text-on-surface-container-low',
    'rounded',
    'border-sm',
    'border-outline-variant',
    'border-opacity-100',
    'bg-surface-container-low',
  ],
  variant: 'outlined',
};
